(function () {
  'use strict';

  if (window.__DLTShippingRatesPhase2Initialized) return;
  window.__DLTShippingRatesPhase2Initialized = true;

  var SHOP_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SESSION_KEY = 'dlt_shipping_quote_v1';
  var MAX_POLL_ATTEMPTS = 16;
  var POLL_DELAY_MS = 550;
  var REQUEST_TIMEOUT_MS = 16000;

  var UF_TO_REGION = {
    SP: 'sp',
    ES: 'sul_sudeste', MG: 'sul_sudeste', RJ: 'sul_sudeste', PR: 'sul_sudeste', RS: 'sul_sudeste', SC: 'sul_sudeste',
    DF: 'centro_oeste', GO: 'centro_oeste', MT: 'centro_oeste', MS: 'centro_oeste',
    AL: 'nordeste', BA: 'nordeste', CE: 'nordeste', PB: 'nordeste', PE: 'nordeste', PI: 'nordeste', RN: 'nordeste', SE: 'nordeste', MA: 'nordeste',
    AC: 'norte', AP: 'norte', AM: 'norte', PA: 'norte', RO: 'norte', RR: 'norte', TO: 'norte'
  };

  var moneyFormatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  var dateFormatter = new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: 'short' });

  function onlyDigits(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 8);
  }

  function formatCep(value) {
    var digits = onlyDigits(value);
    return digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
  }

  function showShippingToast(message, type, options) {
    var opts = options || {};
    var payload = {
      variant: type === 'error' ? 'error' : 'standard',
      title: opts.title || (type === 'error' ? 'Frete não atualizado' : 'Frete atualizado'),
      product: message || '',
      microcopy: opts.microcopy || '',
      showButton: false,
      action: ''
    };

    function deliver() {
      if (typeof window.dltShowToast === 'function') {
        window.dltShowToast(payload);
        return;
      }
      window.dispatchEvent(new CustomEvent('dlt:toast', { detail: payload }));
    }

    if (typeof window.dltShowToast === 'function') {
      deliver();
      return;
    }

    if (typeof window.dltEnsureToastRuntime === 'function') {
      try {
        Promise.resolve(window.dltEnsureToastRuntime()).then(function (loaded) {
          if (loaded !== false) deliver();
        }).catch(function () {});
      } catch (error) {}
      return;
    }

    deliver();
  }

  function safeJsonParse(value, fallback) {
    try { return JSON.parse(value); } catch (error) { return fallback; }
  }

  function readSessionState() {
    try {
      var stored = safeJsonParse(window.sessionStorage.getItem(SESSION_KEY), null);
      if (!stored || !stored.cep) return null;
      stored.cep = onlyDigits(stored.cep);
      return stored.cep.length === 8 ? stored : null;
    } catch (error) {
      return null;
    }
  }

  function writeSessionState(state) {
    try {
      if (!state || !state.cep) {
        window.sessionStorage.removeItem(SESSION_KEY);
        return;
      }
      window.sessionStorage.setItem(SESSION_KEY, JSON.stringify({
        cep: state.cep,
        uf: state.uf || '',
        city: state.city || '',
        regionKey: state.regionKey || '',
        rates: Array.isArray(state.rates) ? state.rates : [],
        hasFreeRate: typeof state.hasFreeRate === 'boolean' ? state.hasFreeRate : null,
        status: state.status || 'idle',
        quotedAt: Number(state.quotedAt) || 0
      }));
    } catch (error) {}
  }

  function wait(ms, signal) {
    return new Promise(function (resolve, reject) {
      var timer = window.setTimeout(resolve, ms);
      if (!signal) return;
      signal.addEventListener('abort', function () {
        window.clearTimeout(timer);
        reject(new DOMException('Aborted', 'AbortError'));
      }, { once: true });
    });
  }

  function normalizeDate(value) {
    if (!value) return '';
    var date = new Date(String(value).slice(0, 10) + 'T12:00:00');
    if (Number.isNaN(date.getTime())) return '';
    return dateFormatter.format(date).replace('.', '');
  }

  function deliveryText(rate) {
    if (rate.delivery_date) {
      var singleDate = normalizeDate(rate.delivery_date);
      if (singleDate) return 'Entrega estimada: ' + singleDate;
    }

    if (Array.isArray(rate.delivery_range) && rate.delivery_range.length >= 2) {
      var from = normalizeDate(rate.delivery_range[0]);
      var to = normalizeDate(rate.delivery_range[1]);
      if (from && to) return 'Entrega estimada: ' + from + ' a ' + to;
    }

    if (Array.isArray(rate.delivery_days) && rate.delivery_days.length) {
      var days = rate.delivery_days.map(function (item) { return Number(item); }).filter(Number.isFinite);
      if (days.length === 1) return 'Prazo informado: ' + days[0] + ' dias';
      if (days.length >= 2) return 'Prazo informado: ' + Math.min.apply(Math, days) + ' a ' + Math.max.apply(Math, days) + ' dias';
    }

    return '';
  }

  function normalizeRateCopy(value) {
    if (!value) return '';
    return String(value)
      .replace(/\s+/g, ' ')
      .replace(/envio no dia seguinte/ig, 'Envio no próximo dia útil')
      .replace(/entrega no dia seguinte/ig, 'Entrega no próximo dia útil')
      .trim();
  }

  function normalizeRates(payload) {
    var list = payload && Array.isArray(payload.shipping_rates) ? payload.shipping_rates : [];
    return list.map(function (rate) {
      var rawPrice = String(rate.price == null ? '0' : rate.price).replace(',', '.');
      var price = Number.parseFloat(rawPrice);
      if (!Number.isFinite(price)) price = 0;
      return {
        name: normalizeRateCopy(rate.presentment_name || rate.name || rate.code || 'Entrega'),
        code: rate.code || rate.name || '',
        price: price,
        currency: rate.currency || 'BRL',
        description: normalizeRateCopy(rate.description || ''),
        deliveryText: normalizeRateCopy(deliveryText(rate))
      };
    });
  }

  function getRegionFromUf(uf) {
    return UF_TO_REGION[String(uf || '').trim().toUpperCase()] || '';
  }

  async function fetchJson(url, options) {
    var response = await fetch(url, options || {});
    var payload = await response.json().catch(function () { return null; });
    if (!response.ok) {
      var error = new Error('HTTP ' + response.status);
      error.status = response.status;
      error.payload = payload;
      throw error;
    }
    return payload;
  }

  async function resolveAddress(cep, signal) {
    var firstError = null;

    try {
      var via = await fetchJson('https://viacep.com.br/ws/' + cep + '/json/', {
        method: 'GET',
        headers: { Accept: 'application/json' },
        signal: signal
      });
      if (via && !via.erro && via.uf) {
        return { uf: String(via.uf).toUpperCase(), city: via.localidade || '' };
      }
      firstError = new Error('invalid_cep');
    } catch (error) {
      if (error && error.name === 'AbortError') throw error;
      firstError = error;
    }

    try {
      var brasil = await fetchJson('https://brasilapi.com.br/api/cep/v2/' + cep, {
        method: 'GET',
        headers: { Accept: 'application/json' },
        signal: signal
      });
      if (brasil && brasil.state) {
        return { uf: String(brasil.state).toUpperCase(), city: brasil.city || '' };
      }
    } catch (error) {
      if (error && error.name === 'AbortError') throw error;
    }

    return { uf: '', city: '', lookupError: firstError ? String(firstError.message || '') : '' };
  }

  function shippingParams(cep, address) {
    var params = new URLSearchParams();
    params.set('shipping_address[zip]', formatCep(cep));
    params.set('shipping_address[country]', 'Brazil');
    if (address && address.uf) params.set('shipping_address[province]', address.uf);
    return params.toString();
  }

  async function getCurrentCart(signal) {
    return fetchJson(SHOP_ROOT + 'cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' },
      signal: signal
    });
  }

  async function requestShippingRates(cep, address, signal) {
    var query = shippingParams(cep, address);
    var prepareUrl = SHOP_ROOT + 'cart/prepare_shipping_rates.json?' + query;
    var asyncUrl = SHOP_ROOT + 'cart/async_shipping_rates.json?' + query;

    await fetchJson(prepareUrl, {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' },
      signal: signal
    });

    for (var attempt = 0; attempt < MAX_POLL_ATTEMPTS; attempt += 1) {
      await wait(attempt === 0 ? 180 : POLL_DELAY_MS, signal);
      var payload = await fetchJson(asyncUrl, {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
        signal: signal
      });
      if (payload !== null) return payload;
    }

    var timeoutError = new Error('rates_timeout');
    timeoutError.code = 'rates_timeout';
    throw timeoutError;
  }

  var restored = readSessionState();
  var state = restored ? {
    cep: restored.cep,
    uf: restored.uf || '',
    city: restored.city || '',
    regionKey: restored.regionKey || getRegionFromUf(restored.uf),
    rates: Array.isArray(restored.rates) ? restored.rates : [],
    hasFreeRate: typeof restored.hasFreeRate === 'boolean' ? restored.hasFreeRate : null,
    status: 'stale',
    error: '',
    quotedAt: Number(restored.quotedAt) || 0
  } : {
    cep: '', uf: '', city: '', regionKey: '', rates: [], hasFreeRate: null,
    status: 'idle', error: '', quotedAt: 0
  };

  var subscribers = new Set();
  var activeController = null;
  var refreshTimer = null;
  var started = false;

  function publicState() {
    return {
      cep: state.cep,
      uf: state.uf,
      city: state.city,
      regionKey: state.regionKey,
      rates: state.rates.slice(),
      hasFreeRate: state.hasFreeRate,
      status: state.status,
      error: state.error,
      quotedAt: state.quotedAt
    };
  }

  function emit() {
    writeSessionState(state);
    var snapshot = publicState();
    subscribers.forEach(function (listener) {
      try { listener(snapshot); } catch (error) {}
    });
    document.dispatchEvent(new CustomEvent('dlt:shipping:updated', { detail: { shipping: snapshot } }));
  }

  function stateErrorMessage(error) {
    if (!error) return 'Não foi possível calcular o frete agora. Tente novamente.';
    if (error.name === 'AbortError') return 'A consulta foi interrompida. Tente novamente.';
    if (error.code === 'rates_timeout' || error.message === 'rates_timeout') return 'A Shopify demorou mais que o esperado para calcular as taxas. Tente novamente.';
    if (error.status === 422) return 'Não foi possível calcular a entrega para este CEP e carrinho.';
    return 'Não foi possível consultar as taxas da Shopify agora. Tente novamente em instantes.';
  }

  async function quote(cep, options) {
    options = options || {};
    cep = onlyDigits(cep);
    if (cep.length !== 8) {
      state = Object.assign({}, state, { status: 'error', error: 'Informe um CEP válido com 8 números.' });
      emit();
      return publicState();
    }

    if (activeController) activeController.abort();
    activeController = new AbortController();
    var controller = activeController;
    var timeout = window.setTimeout(function () { controller.abort(); }, REQUEST_TIMEOUT_MS);

    var sameCep = state.cep === cep;
    state = Object.assign({}, state, {
      cep: cep,
      uf: sameCep ? state.uf : '',
      city: sameCep ? state.city : '',
      regionKey: sameCep ? state.regionKey : '',
      rates: sameCep ? state.rates : [],
      status: 'loading',
      error: '',
      hasFreeRate: null
    });
    emit();

    try {
      var results = await Promise.all([
        getCurrentCart(controller.signal),
        resolveAddress(cep, controller.signal)
      ]);
      var cart = results[0];
      var address = results[1] || { uf: '', city: '' };

      if (!cart || !cart.item_count) {
        state = Object.assign({}, state, {
          uf: address.uf || '',
          city: address.city || '',
          regionKey: getRegionFromUf(address.uf),
          rates: [],
          hasFreeRate: null,
          status: 'error',
          error: 'Adicione um produto ao carrinho antes de calcular a entrega.'
        });
        emit();
        return publicState();
      }

      if (cart.requires_shipping === false) {
        state = Object.assign({}, state, {
          uf: address.uf || '', city: address.city || '', regionKey: getRegionFromUf(address.uf),
          rates: [], hasFreeRate: null, status: 'ready', error: '', quotedAt: Date.now()
        });
        emit();
        return publicState();
      }

      var payload = await requestShippingRates(cep, address, controller.signal);
      var rates = normalizeRates(payload);
      var regionKey = getRegionFromUf(address.uf);
      var hasFreeRate = rates.some(function (rate) { return Number(rate.price) === 0; });

      state = {
        cep: cep,
        uf: address.uf || '',
        city: address.city || '',
        regionKey: regionKey,
        rates: rates,
        hasFreeRate: hasFreeRate,
        status: 'ready',
        error: '',
        quotedAt: Date.now()
      };
      emit();
      return publicState();
    } catch (error) {
      if (controller !== activeController) return publicState();
      state = Object.assign({}, state, {
        status: 'error',
        error: stateErrorMessage(error),
        hasFreeRate: null
      });
      emit();
      return publicState();
    } finally {
      window.clearTimeout(timeout);
      if (controller === activeController) activeController = null;
    }
  }

  function clear() {
    if (activeController) activeController.abort();
    activeController = null;
    state = { cep: '', uf: '', city: '', regionKey: '', rates: [], hasFreeRate: null, status: 'idle', error: '', quotedAt: 0 };
    try { window.sessionStorage.removeItem(SESSION_KEY); } catch (error) {}
    emit();
  }

  function scheduleRefresh() {
    if (!state.cep) return;
    window.clearTimeout(refreshTimer);
    state = Object.assign({}, state, { status: 'stale', error: '' });
    emit();
    refreshTimer = window.setTimeout(function () {
      quote(state.cep, { reason: 'cart-change' });
    }, 900);
  }

  function subscribe(listener) {
    subscribers.add(listener);
    listener(publicState());
    return function () { subscribers.delete(listener); };
  }

  function start() {
    if (started) return;
    started = true;
    if (state.cep) window.setTimeout(function () { quote(state.cep, { reason: 'restore' }); }, 120);
  }

  window.DLTShippingRates = {
    quote: quote,
    clear: clear,
    getState: publicState,
    subscribe: subscribe,
    formatCep: formatCep,
    getRegionFromUf: getRegionFromUf,
    refresh: scheduleRefresh
  };

  function cartEventHandler() {
    if (!state.cep) return;
    scheduleRefresh();
  }

  ['line-item:change', 'variant:add', 'cart:change', 'cart:state', 'cart:refresh', 'dlt:cart:updated'].forEach(function (name) {
    document.addEventListener(name, cartEventHandler);
  });
  window.addEventListener('cart-update', cartEventHandler);

  class DltShippingRatesElement extends HTMLElement {
    constructor() {
      super();
      this.unsubscribe = null;
      this.context = this.dataset.context || 'drawer';
      this.onSubmit = this.onSubmit.bind(this);
      this.onReset = this.onReset.bind(this);
      this.onInput = this.onInput.bind(this);
      this.openModal = this.openModal.bind(this);
      this.closeModal = this.closeModal.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
    }

    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';
      this.form = this.querySelector('[data-dlt-shipping-form]');
      this.input = this.querySelector('[data-dlt-shipping-cep]');
      this.button = this.querySelector('[data-dlt-shipping-submit]');
      this.buttonText = this.querySelector('[data-dlt-shipping-submit-text]');
      this.feedback = this.querySelector('[data-dlt-shipping-feedback]');
      this.feedbackModal = this.querySelector('[data-dlt-shipping-feedback-modal]');
      this.destination = this.querySelector('[data-dlt-shipping-destination]');
      this.destinationTitle = this.querySelector('[data-dlt-shipping-destination-title]');
      this.destinationMeta = this.querySelector('[data-dlt-shipping-destination-meta]');
      this.results = this.querySelector('[data-dlt-shipping-results]');
      this.summary = this.querySelector('[data-dlt-shipping-summary]');
      this.summaryMeta = this.querySelector('[data-dlt-shipping-summary-meta]');
      this.disclosure = this.querySelector('[data-dlt-shipping-disclosure]');
      this.utilityPill = this.querySelector('[data-dlt-shipping-pill]');
      this.resetButton = this.querySelector('[data-dlt-shipping-reset]');
      this.launcher = null;
      this.launcherLabel = null;
      this.changeButton = this.querySelector('[data-dlt-shipping-change]');
      this.modal = null;
      this.modalCloseButtons = [];

      if (this.form) this.form.addEventListener('submit', this.onSubmit);
      if (this.input) this.input.addEventListener('input', this.onInput);
      if (this.resetButton) this.resetButton.addEventListener('click', this.onReset);
      if (this.changeButton) this.changeButton.addEventListener('click', this.onReset);
      if (this.modalCloseButtons && this.modalCloseButtons.length) {
        this.modalCloseButtons.forEach(function (button) {
          button.addEventListener('click', this.closeModal);
        }, this);
      }
      if (this.modal) document.addEventListener('keydown', this.onKeydown);

      this.unsubscribe = subscribe(this.render.bind(this));
      start();
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      if (this.modal) document.removeEventListener('keydown', this.onKeydown);
    }

    onInput() {
      if (!this.input) return;
      this.input.value = formatCep(this.input.value);
      this.input.removeAttribute('aria-invalid');
    }

    onSubmit(event) {
      event.preventDefault();
      var cep = onlyDigits(this.input && this.input.value);
      if (cep.length !== 8) {
        if (this.input) {
          this.input.setAttribute('aria-invalid', 'true');
          this.input.focus();
        }
        this.showFeedback('Informe um CEP válido com 8 números.', 'error');
        showShippingToast('Informe um CEP válido com 8 números.', 'error', {
          title: 'CEP inválido',
          microcopy: 'Use os 8 números do CEP para calcular a entrega.'
        });
        return;
      }

      var self = this;
      quote(cep, { reason: 'user' }).then(function (snapshot) {
        if (!snapshot) return;

        if (snapshot.status === 'ready') {
          if (self.disclosure) self.disclosure.open = false;

          var locationLabel = snapshot.city && snapshot.uf
            ? snapshot.city + ' · ' + snapshot.uf
            : (snapshot.uf ? snapshot.uf : 'CEP ' + formatCep(snapshot.cep || cep));
          var rateCount = Array.isArray(snapshot.rates) ? snapshot.rates.length : 0;
          var message = snapshot.hasFreeRate
            ? 'Frete grátis disponível · ' + locationLabel
            : 'Entrega calculada · ' + locationLabel;
          var microcopy = snapshot.hasFreeRate
            ? 'Seu carrinho possui uma modalidade de frete grátis.'
            : (rateCount > 0
              ? rateCount + (rateCount === 1 ? ' opção de entrega disponível.' : ' opções de entrega disponíveis.')
              : 'As condições de entrega foram atualizadas.');

          showShippingToast(message, 'success', {
            title: 'Frete atualizado',
            microcopy: microcopy
          });
          return;
        }

        if (snapshot.status === 'error') {
          showShippingToast(snapshot.error || 'Não foi possível calcular o frete.', 'error', {
            title: 'Frete não calculado',
            microcopy: 'Confira o CEP e tente novamente.'
          });
        }
      }).catch(function () {
        showShippingToast('Não foi possível calcular o frete agora.', 'error', {
          title: 'Frete não calculado',
          microcopy: 'Tente novamente em instantes.'
        });
      });
    }

    onReset() {
      clear();
      if (this.input) {
        this.input.value = '';
        this.input.focus();
      }
      showShippingToast('CEP removido do cálculo de entrega.', 'success', {
        title: 'Frete redefinido',
        microcopy: 'Informe um novo CEP quando quiser recalcular.'
      });
    }

    onKeydown(event) {
      if (!event || event.key !== 'Escape') return;
      if (!this.modal || this.modal.hidden) return;
      this.closeModal();
    }

    openModal() {
      if (!this.modal) return;
      this.modal.hidden = false;
      this.modal.classList.add('is-open');
      document.documentElement.classList.add('dlt-shipping-modal-open');
      if (this.input) {
        if (state.cep && !this.input.value) this.input.value = formatCep(state.cep);
        window.setTimeout(function (input) {
          try { input.focus({ preventScroll: true }); } catch (error) { input.focus(); }
          input.select();
        }, 30, this.input);
      }
    }

    closeModal() {
      if (!this.modal) return;
      this.modal.hidden = true;
      this.modal.classList.remove('is-open');
      document.documentElement.classList.remove('dlt-shipping-modal-open');
    }

    showFeedback(message, type) {
      var elements = [this.feedback, this.feedbackModal].filter(Boolean);
      elements.forEach(function (element) {
        element.textContent = message;
        element.dataset.state = type || 'info';
        element.hidden = !message;
      });
    }

    setLoading(loading) {
      this.setAttribute('aria-busy', String(Boolean(loading)));
      if (this.button) this.button.disabled = Boolean(loading);
      if (this.buttonText) this.buttonText.textContent = loading ? 'Calculando' : 'Calcular';
      if (this.launcher) this.launcher.disabled = Boolean(loading);
      if (this.launcherLabel) {
        this.launcherLabel.textContent = loading ? 'Atualizando' : (state.cep ? 'Alterar CEP' : 'Informar CEP');
      }
    }

    renderRates(rates) {
      if (!this.results) return;
      this.results.replaceChildren();
      if (!rates.length) {
        this.results.hidden = true;
        return;
      }

      rates.forEach(function (rate) {
        var item = document.createElement('li');
        item.className = 'dlt-shipping-rates__result' + (rate.price === 0 ? ' is-free' : '');

        var copy = document.createElement('span');
        copy.className = 'dlt-shipping-rates__result-copy';
        var name = document.createElement('strong');
        name.className = 'dlt-shipping-rates__result-name';
        name.textContent = rate.name || 'Entrega';
        copy.appendChild(name);

        var metaParts = [];
        if (rate.deliveryText) metaParts.push(rate.deliveryText);
        if (rate.description) metaParts.push(rate.description);
        if (metaParts.length) {
          var meta = document.createElement('small');
          meta.className = 'dlt-shipping-rates__result-meta';
          meta.textContent = metaParts.join(' · ');
          copy.appendChild(meta);
        }

        var price = document.createElement('strong');
        price.className = 'dlt-shipping-rates__result-price';
        price.textContent = rate.price === 0 ? 'GRÁTIS' : moneyFormatter.format(rate.price);
        item.append(copy, price);
        this.results.appendChild(item);
      }, this);
      this.results.hidden = false;
    }

    render(nextState) {
      var loading = nextState.status === 'loading' || nextState.status === 'stale';
      this.setLoading(loading);
      this.classList.toggle('is-quoted', Boolean(nextState.cep && nextState.status !== 'error'));

      if (this.input && document.activeElement !== this.input && nextState.cep) {
        this.input.value = formatCep(nextState.cep);
      }

      if (this.form) {
        this.form.hidden = Boolean(nextState.cep && nextState.status !== 'error');
      }

      var isPdp = this.context === 'pdp';

      if (nextState.cep) {
        if (this.summary) this.summary.textContent = isPdp ? 'Entrega para o seu CEP' : 'Frete';
        if (this.summaryMeta) {
          if (loading) {
            this.summaryMeta.textContent = 'Atualizando';
          } else if (nextState.status === 'ready' && nextState.rates.length) {
            this.summaryMeta.textContent = nextState.uf || 'Calculado';
          } else {
            this.summaryMeta.textContent = 'CEP ' + formatCep(nextState.cep);
          }
        }
        if (this.utilityPill) {
          if (loading) {
            this.utilityPill.textContent = '…';
          } else if (nextState.status === 'ready' && nextState.rates.length) {
            var firstPrice = nextState.rates[0].price;
            this.utilityPill.textContent = Number(firstPrice) === 0 ? 'GRÁTIS' : moneyFormatter.format(firstPrice);
          } else {
            this.utilityPill.textContent = '›';
          }
        }
      } else {
        if (this.summary) this.summary.textContent = isPdp ? 'Entrega para o seu CEP' : 'Frete';
        if (this.summaryMeta) this.summaryMeta.textContent = isPdp ? 'Calcular prazo e frete' : 'CEP';
        if (this.utilityPill) this.utilityPill.textContent = '+';
      }

      if (this.launcherLabel && !loading) {
        this.launcherLabel.textContent = nextState.cep ? 'Alterar CEP' : 'Informar CEP';
      }

      if (nextState.status === 'loading') {
        this.showFeedback('Consultando modalidades disponíveis...', 'info');
      } else if (nextState.status === 'stale') {
        this.showFeedback('Carrinho atualizado. Recalculando a entrega...', 'info');
      } else if (nextState.status === 'error') {
        this.showFeedback(nextState.error || 'Não foi possível calcular a entrega.', 'error');
      } else if (nextState.status === 'ready' && !nextState.rates.length) {
        this.showFeedback('A Shopify não retornou modalidades de entrega para este CEP no momento.', 'info');
      } else {
        this.showFeedback('', 'info');
      }

      if (this.destination) {
        this.destination.hidden = !nextState.cep || nextState.status === 'error';
        if (!this.destination.hidden) {
          var title = nextState.city && nextState.uf ? nextState.city + ' · ' + nextState.uf : (nextState.uf || 'CEP ' + formatCep(nextState.cep));
          if (this.destinationTitle) this.destinationTitle.textContent = title;
          if (this.destinationMeta) this.destinationMeta.textContent = 'CEP ' + formatCep(nextState.cep);
        }
      }

      this.renderRates(nextState.status === 'ready' ? nextState.rates : []);
    }

  }


  if (!window.__DLTCartUtilityPairToggleBound) {
    window.__DLTCartUtilityPairToggleBound = true;
    document.addEventListener('toggle', function (event) {
      var details = event.target;
      if (!details || details.tagName !== 'DETAILS' || !details.open) return;
      var pair = details.closest && details.closest('[data-dlt-cart-utility-pair]');
      if (!pair) return;
      pair.querySelectorAll('details[open]').forEach(function (other) {
        if (other !== details) other.open = false;
      });
    }, true);
  }

  if (!customElements.get('dlt-shipping-rates')) {
    customElements.define('dlt-shipping-rates', DltShippingRatesElement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
